import {dialogApi} from '../../../../../api/dialogApi'
import styles from './TrendingTopicsCard.module.scss'
import {
  useWuShowToast,
  WuCard,
  WuCardHeader,
  WuHeading,
  WuIcon,
} from '@npm-questionpro/wick-ui-lib'
import {useEffect, useState} from 'react'
import {TopicModal} from './TopicModal/TopicModal'
import {ActionModal} from './ActionModal/ActionModal'
import {useParams} from 'react-router'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../Translation/English/dialog'
import type {IDialogTrendingTopic} from '../../../../../types/dialogTypes'

export const TrendingTopicsCard: React.FC = () => {
  const wt = useWt()
  const {showToast} = useWuShowToast()
  const updateDialogMutation = dialogApi.useUpdateDialog()
  const {dialogId} = useParams<{dialogId: string}>()

  const [actionTopics, setActionTopics] = useState<string[]>([])
  const [showTopicModal, setShowTopicModal] = useState<boolean>(false)
  const [showActionModal, setShowActionModal] = useState<boolean>(false)
  const [selectedTopic, setSelectedTopic] =
    useState<IDialogTrendingTopic | null>(null)
  const {data: analyticsData} = dialogApi.useDialogAnalytics(dialogId ?? '')
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '')
  const actionTakenTopics = dialogDetails?.actionTakenTopics

  useEffect(() => {
    setActionTopics(actionTakenTopics || [])
  }, [actionTakenTopics])

  const handleTopicClick = (topic: IDialogTrendingTopic): void => {
    setSelectedTopic(topic)
    setShowTopicModal(true)
  }
  const handleActionClick = (topic: IDialogTrendingTopic): void => {
    setSelectedTopic(topic)
    setShowActionModal(true)
  }

  const persistActionTopic = async (topicName: string): Promise<void> => {
    const detailsId = dialogDetails?.id
    if (!topicName || !detailsId || actionTopics.includes(topicName)) return

    const previousTopics = [...actionTopics]
    const updatedTopics = [...actionTopics, topicName]
    setActionTopics(updatedTopics)
    try {
      await updateDialogMutation.mutateAsync({
        id: detailsId,
        actionTakenTopics: updatedTopics,
      })
    } catch {
      setActionTopics(previousTopics)
      showToast({message: wt(DIALOG.failedToSaveActionTopic), variant: 'error'})
    }
  }

  return (
    <>
      <WuCard rounded>
        <WuCardHeader className={styles.cardHeading}>
          <WuHeading size="sm">{wt(DIALOG.trendingTopics)}</WuHeading>
        </WuCardHeader>
        <div className={styles.trendingTopicsContainer}>
          {analyticsData?.trending_topics?.map(topic => (
            <div key={topic.topic} className={styles.trendingTopicsRow}>
              <div
                className={styles.trendingTopicsLabel}
                onClick={() => handleTopicClick(topic)}
              >
                <div className={styles.trendingTopicsLabelName}>
                  {topic.topic}
                </div>
                <div className={styles.trendingTopicsLabelCount}>
                  {topic.responses?.length || 1}
                </div>
              </div>
              {dialogDetails?.isAchived && (
                <>
                  {actionTopics.indexOf(topic.topic) !== -1 ? (
                    <WuIcon
                      icon="wm-check-circle"
                      className={styles.trendingTopicsCircleIcon}
                    />
                  ) : (
                    <WuIcon
                      icon="wm-bolt"
                      className={styles.trendingTopicsBoltIcon}
                      onClick={() => handleActionClick(topic)}
                    />
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </WuCard>
      {showTopicModal && (
        <TopicModal
          showModal={showTopicModal}
          closeModal={() => {
            setShowTopicModal(false)
            setSelectedTopic(null)
          }}
          data={selectedTopic}
        />
      )}
      {showActionModal && (
        <ActionModal
          showModal={showActionModal}
          closeModal={topicName => {
            setShowActionModal(false)
            setSelectedTopic(null)
            void persistActionTopic(topicName)
          }}
          data={selectedTopic}
        />
      )}
    </>
  )
}
